import React, { useEffect, useState } from 'react';
import { InstantVoiceUpload, OnboardingContainer } from '../../../components';
import {
  CardsContainer,
  CardText,
  ChooseTabText,
  Content,
  Header,
  HeaderContainer,
  HeaderText,
  Row1,
  SectionText,
  StyledButton1,
  TabCard,
  TabCardsContainer,
  TabCardText,
  TipCard,
} from './UploadVoicePage.styles';
import { Text15Regular, Text18Bold, Text20Bold } from '../../../components/utils/Text/Text.styles';
import { ReactComponent as MicrophoneIcon } from '../../../assets/icons/microphone-01.svg';
import { ReactComponent as VoicemailIcon } from '../../../assets/icons/voicemail.svg';
import { ReactComponent as MicrophoneOffIcon } from '../../../assets/icons/microphone-off.svg';
import { ReactComponent as RecordingIcon } from '../../../assets/icons/recording-02.svg';
import { ReactComponent as Recording1Icon } from '../../../assets/icons/recording-03.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectInfluencerRequestActionsPending } from '../../../store/slices/influencerRequest/slice';
import { useConfirmationModal } from '../../../components/modals/ConfirmationModal/ConfirmationModal';
import { saveVoiceElevenLabs } from '../../../store/slices/influencerRequest/asyncThunks';
import { setUserStatus } from '../../../store/slices/user/slice';
import { notifyError } from '../../../utils/notify';

const TABS = {
  INSTANT_CLONING: 'INSTANT_CLONING',
  HIGH_QUALITY_CLONING: 'HIGH_QUALITY_CLONING',
};

const UploadVoicePage = () => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(null);
  const [openModal, closeModal, setConfirmationModalLoader] = useConfirmationModal();

  const { saveVoice: saveVoicePending } = useSelector(selectInfluencerRequestActionsPending);

  useEffect(() => {
    setConfirmationModalLoader(saveVoicePending);
  }, [saveVoicePending, setConfirmationModalLoader]);

  return (
    <OnboardingContainer>
      <Content>
        <HeaderContainer>
          <Text20Bold>Voice Settings</Text20Bold>
        </HeaderContainer>
        {!selectedTab && (
          <>
            <Header>
              <Text18Bold>Clone Your Voice</Text18Bold>
              <HeaderText>
                Record your voice or upload a voice file.
                <br /> We’ll use this sample to clone your voice so your profile can send voice notes.
              </HeaderText>
            </Header>
            <SectionText>Tips for the best results</SectionText>
            <CardsContainer>
              <TipCard>
                <MicrophoneIcon color="#1672BA" />
                <CardText>Speak clearly and naturally — your voice will be cloned exactly as you say it.</CardText>
              </TipCard>
              <TipCard>
                <RecordingIcon />
                <CardText>Avoid background noise — even subtle sounds can impact how your voice is cloned.</CardText>
              </TipCard>
              <TipCard>
                <VoicemailIcon />
                <CardText>Want a seductive tone? Speak with a seductive voice when recording.</CardText>
              </TipCard>
            </CardsContainer>
            <ChooseTabText>Choose how you want to clone your voice</ChooseTabText>
            <TabCardsContainer>
              <TabCard onClick={() => setSelectedTab(TABS.INSTANT_CLONING)}>
                <Row1>
                  <Recording1Icon />
                  <Text15Regular>Instant Cloning</Text15Regular>
                </Row1>
                <TabCardText> 10–20 seconds of audio – test it right away</TabCardText>
                <StyledButton1 title="Select Instant Cloning" />
              </TabCard>
              <TabCard
                onClick={() =>
                  openModal(
                    'Turn Off Voice',
                    `Are you sure? Voice features will be disabled.`,
                    'Turn Off',
                    () => {
                      dispatch(saveVoiceElevenLabs({}))
                        .unwrap()
                        .then(({ userStatus }) => {
                          closeModal();
                          dispatch(setUserStatus(userStatus));
                        })
                        .catch(err => {
                          notifyError(err.message);
                        });
                    },
                    'Cancel',
                    () => {
                      closeModal();
                    },
                  )
                }>
                <Row1>
                  <MicrophoneOffIcon />
                  <Text15Regular>Turn Off Voice</Text15Regular>
                </Row1>
                <TabCardText>You don’t want to use voice recordings</TabCardText>
                <StyledButton1 title="Turn Off Voice Cloning" />
              </TabCard>
            </TabCardsContainer>
          </>
        )}
        {selectedTab === TABS.INSTANT_CLONING && <InstantVoiceUpload setSelectedTab={setSelectedTab} />}
      </Content>
    </OnboardingContainer>
  );
};

export default UploadVoicePage;
